__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "login";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("i18next", "25.10.10", function() { return __webpack_require__.e(7061).then(function() { return function() { return __webpack_require__(7061); }; }); });
			register("next/dynamic", "14.2.16", function() { return Promise.all([__webpack_require__.e(5724), __webpack_require__.e(9167)]).then(function() { return function() { return __webpack_require__(9167); }; }); });
			register("next/head", "14.2.16", function() { return Promise.all([__webpack_require__.e(5724), __webpack_require__.e(1434)]).then(function() { return function() { return __webpack_require__(1434); }; }); });
			register("next/image", "14.2.16", function() { return Promise.all([__webpack_require__.e(6783), __webpack_require__.e(5724), __webpack_require__.e(3517), __webpack_require__.e(3166)]).then(function() { return function() { return __webpack_require__(6783); }; }); });
			register("next/link", "14.2.16", function() { return Promise.all([__webpack_require__.e(1629), __webpack_require__.e(5212), __webpack_require__.e(5724), __webpack_require__.e(3188)]).then(function() { return function() { return __webpack_require__(5212); }; }); });
			register("next/router", "14.2.16", function() { return Promise.all([__webpack_require__.e(1629), __webpack_require__.e(3432), __webpack_require__.e(2825), __webpack_require__.e(5724), __webpack_require__.e(3517), __webpack_require__.e(144)]).then(function() { return function() { return __webpack_require__(2025); }; }); });
			register("next/script", "14.2.16", function() { return Promise.all([__webpack_require__.e(3432), __webpack_require__.e(5724), __webpack_require__.e(3517), __webpack_require__.e(7556)]).then(function() { return function() { return __webpack_require__(5771); }; }); });
			register("react-dom/client", "18.3.1", function() { return Promise.all([__webpack_require__.e(6593), __webpack_require__.e(3517)]).then(function() { return function() { return __webpack_require__(8997); }; }); });
			register("react-dom", "18.3.1", function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(316); }; }); });
			register("react-i18next", "15.7.4", function() { return __webpack_require__.e(9565).then(function() { return function() { return __webpack_require__(9565); }; }); });
			register("react/jsx-runtime", "18.13.1", function() { return function() { return __webpack_require__(5723); }; }, 1);
			register("react", "18.3.1", function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(2155); }; }); });
			register("styled-jsx/style", "5.1.1", function() { return __webpack_require__.e(5235).then(function() { return function() { return __webpack_require__(5235); }; }); });
			register("styled-jsx", "5.1.1", function() { return __webpack_require__.e(3818).then(function() { return function() { return __webpack_require__(3818); }; }); });
			initExternal(5197);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};